{
  "title": "Skogeierlag",
  "description": "Endre skogeierlag",
  "titleHeader": "Endre hvilket skogeierlag du ønsker å knytte til andelseierskapet",
  "noForestownerGroupSelected": "Ingen skogeierlag er valgt"
}
